import React, { Component } from 'react';

//styles
import './sectionSix.scss';

import '../../static/fonts/Rubik/stylesheet.css'

class SectionSix extends Component {
    componentDidMount() {
    }

    render() {
        return (
            <div id="section6" className="section6-container">
                {/* <div className="image"></div> */}
                <div className="desc-container">
                    <div className="title">ממקור ראשון</div>
                    <div className="images-wrapper">
                        <div className="image-container image-r">
                            <div className="image"></div>
                            <div className="image-desc">התחתנתי לא נכון והצטרפתי למעגל העוני</div>
                            <button className="btn" onClick={() => this.props.goToArticle('5355170/44', 'התחתנתי לא נכון והצטרפתי למעגל העוני')}></button>
                        </div>
                        <div className="image-container image-l">
                            <div className="image"></div>
                            <div className="image-desc">כן, יש לי בית ואוטו ואני ענייה חדשה</div>
                            <button className="btn" onClick={() => this.props.goToArticle('5336001/45', 'כן, יש לי בית ואוטו ואני ענייה חדשה')}></button>
                        </div>
                    </div>
                </div>
                <div className="line"></div>
            </div>
        );
    }
}

export default SectionSix;


// WEBPACK FOOTER //
// ./src/Components/SectionSix/SectionSix.js